import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panelcalldetails',
  templateUrl: './panelcalldetails.component.html',
  styleUrls: ['./panelcalldetails.component.scss']
})
export class PanelcalldetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
